import { render, staticRenderFns } from "./tk.vue?vue&type=template&id=54756f16&scoped=true"
import script from "./tk.vue?vue&type=script&lang=js"
export * from "./tk.vue?vue&type=script&lang=js"
import style0 from "./tk.vue?vue&type=style&index=0&id=54756f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54756f16",
  null
  
)

export default component.exports